import { render } from "./HeadSorting.vue?vue&type=template&id=05b853ec&scoped=true"
import script from "./HeadSorting.vue?vue&type=script&lang=js"
export * from "./HeadSorting.vue?vue&type=script&lang=js"

import "./HeadSorting.vue?vue&type=style&index=0&id=05b853ec&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b853ec"]])

export default __exports__